<template>
  <div>
    <div class="select-wrap">
      <div>
        <el-date-picker
          v-model="time"
          @change="onChangeTime"
          :clearable="false"
          unlink-panels
          type="daterange"
          format="yyyy-MM-dd"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small">
        </el-date-picker>
      </div>
      <div class="checkbox">
        <el-checkbox-group v-model="checkedList" @change="onChangeCheck">
          <el-checkbox v-for="item in plainOptions" :label="item.value" :key="item.value">{{item.label}}</el-checkbox>
        </el-checkbox-group>
      </div>
      <!-- 2021 11 05  新增公司下拉列表筛选 -->
      <div class="select-company">
         <el-select v-model="corpId" size="small" multiple placeholder="请选择公司">
            <el-option
              v-for="item in cropOptions"
              :key="item.corpId"
              :label="item.corpName"
              :value="item.corpId">
            </el-option>
        </el-select>
      </div>
      <div>
          <el-button type="primary" @click="getData" size="small">查询</el-button>
          <el-button type="primary" @click="exportDetail" size="small">导出明细</el-button>
      </div>
    </div>
    <div class="jzbWrap">
      <el-table :data="tableData" style="width: 100%" v-loading="loading"  @expand-change="expandChange" :row-key="row=> row.id + '-' + row.orderNumber">
        <el-table-column type="expand" >
          <template slot-scope="scope">
            <div  v-loading="scope.row.loading">
             <el-table :data="scope.row.list" style="width:100%">
               <el-table-column prop="skuCode" label="商品编号">
                </el-table-column>
                <el-table-column prop="skuName" label="商品名称">
                </el-table-column>
                <el-table-column prop="unitName" label="单位">
                </el-table-column>
                <el-table-column prop="quantity" label="数量">
                </el-table-column>
                <el-table-column prop="price" label="价格">
                </el-table-column>
                <el-table-column prop="amount" label="金额">
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createdOn" label="交易时间">
          <template slot-scope="scope">
            {{moment(scope.row.createdOn).format('YYYY-MM-DD')}}
          </template>
        </el-table-column>
        <el-table-column prop="operationType" label="操作类型">
          <template slot-scope="scope">
            {{scope.row.operationType | filterOperationType}}
          </template>
        </el-table-column>
        <el-table-column prop="orderNumber" label="销售单号"></el-table-column>
        <el-table-column prop="amount" label="交易金额">
          <template slot-scope="scope">
            {{scope.row.amount}}
          </template>
        </el-table-column>
        <!-- 新增字段 2021 11 05 -->
        <el-table-column prop="relativeSubAcctNo" label="见证宝账号"></el-table-column>
        <!-- 新增字段 2021 11 05 -->
        <el-table-column prop="corpName" label="公司"></el-table-column>
      </el-table>
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 50, 100, 200]"
      :page-size="pagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
// cosnt disabledDate = current => current && current > moment().endOf('day') || current < moment().subtract(3, 'months')
import moment from 'moment'
import {jzbTransDetail, jzbTransDetailExport, jzbTransferDetailInfo, jzbCropList} from '@/models/jzbModel'
const plainOptions = [
  {
    label: '订单入账',
    value: 3
  },
  {
    label: '订单撤销',
    value: 4
  },
  // {
  //   label: '转账',
  //   value: 6
  // },
  {
    label: '提现',
    value: 5
  }
]

export default {
  props: ['type'],
  data () {
    return {
      loading: false,
      expandLoading: false,
      plainOptions: plainOptions,
      corpId: [],       // 选择公司id
      cropOptions: [],  // 公司下拉列表
      checkedList: [],
      tableData: [],
      time: [moment().subtract(3, 'months').valueOf(), moment().valueOf()],
      currentPage: 1,
      totalCount: 0,
      pagesize: 10
    }
  },
  filters: {
    filterOperationType (val) {
      let str = ''
      switch (val) {
        case 3:
          str = '订单入账'
          break
        case 4:
          str = '订单撤销'
          break
        case 5:
          str = '提现'
          break
        // case 6:
        //   str = '同名转出'
        //   break

        default:
          break
      }
      return str
    }
  },
  methods: {
    moment,
    onChangeTime (value) {
      this.time = value
      let time = []
      time[0] = Object.assign({}, moment(value[0]))
      time[1] = Object.assign({}, moment(value[1]))
      let startTime = moment(time[0])
      let endtTime = moment(time[1]).subtract(1, 'days')
      if (!endtTime.subtract(3, 'months').isBefore(startTime)) {
        this.$message.error('选择的时间跨度最大为3个月')
        this.time = [moment().subtract(3, 'months').valueOf(), moment().valueOf()]
      } else {
        // this.time[0] = value[0].valueOf()
        // this.time[1] = value[1].valueOf()
        this.time = value
      }
      // let startTime = moment(value[0])
      // let endtTime = moment(value[1])
      // if (!endtTime.subtract(3, 'months').isBefore(startTime)) {
      //   this.$message.error('选择的时间跨度最大为3个月')
      //   this.time = [moment().subtract(3, 'months').valueOf(), moment().valueOf()]
      // } else {
      //   this.time = [startTime.valueOf(), endtTime.add(3, 'months').valueOf()]
      // }
      // this.initData()
    },
    onChangeCheck () {
      // this.initData()
    },
    getData () {
      this.initData()
    },
    /* 
      2021 11 05 新增 公司下拉列表数据
    */
    getCropList () {
      let params = {
        object_type: this.type,
        shopId: Number(localStorage.getItem('shop_id'))
      }
      jzbCropList(params).then((res) => {
        console.log(res, 'res 公司列表')
        if(res.code == 200){
          this.cropOptions = res.data;
        }
      }).catch(err => {
        this.$message.error(err.msg)
      })
    },
    initData () {
      this.loading = true
      /* 
        入参新增 corpId 字段
      */
      let params = {
        objectType: this.type,
        shopId: Number(localStorage.getItem('shop_id')),
        corpId: this.corpId,
        pageIndex: this.currentPage - 1,
        pageSize: this.pagesize
      }
      if (this.checkedList.length === 0) {
        params.operationType = '3,4,5'
      } else {
        params.operationType = this.checkedList.join(',')
      }
      if (this.time.length === 0) {
        params.createdStartOn = moment().subtract(3, 'months').format('YYYY-MM-DD')
        params.createdEndOn = moment().format('YYYY-MM-DD')
      } else {
        params.createdStartOn = moment(this.time[0]).format('YYYY-MM-DD')
        params.createdEndOn = moment(this.time[1]).format('YYYY-MM-DD')
      }
      jzbTransDetail(params).then(res => {
        let list = res.data.content
        list.forEach(item => {
          if (item.operationType === 4 || item.operationType === 5) {
            item.amount = -item.amount
            item.list = []
          }
        })
        this.tableData = list
        this.totalCount = parseInt(res.data.totalElements)
        this.loading = false
      }).catch(err => {
        this.$message.error(err.msg)
      })
    },
    /* 
      导出入参 新加 corpId 字段
    */
    exportDetail () {
      let params = {
        objectType: this.type,
        shopId: Number(localStorage.getItem('shop_id')),
        corpId: this.corpId
      }
      if (this.checkedList.length === 0) {
        params.operationType = '3,4,5'
      } else {
        params.operationType = this.checkedList.join(',')
      }
      if (this.time.length === 0) {
        params.createdStartOn = moment().subtract(3, 'months').format('YYYY-MM-DD')
        params.createdEndOn = moment().format('YYYY-MM-DD')
      } else {
        params.createdStartOn = moment(this.time[0]).format('YYYY-MM-DD')
        params.createdEndOn = moment(this.time[1]).format('YYYY-MM-DD')
      }
      window.open(jzbTransDetailExport(params))
    },
    expandChange (row, expandedRows) {
      let index = this.tableData.findIndex(item => {
        return item.id === row.id
      })
      if (index !== -1) {
        if (row.orderNumber) {
          this.$set(this.tableData[index], 'loading', true)
          jzbTransferDetailInfo(row.orderNumber)
            .then(res => {
              if (res.code === 200) {
                let resData = res.data
                if (resData.length > 0) {
                  row.list = resData[0].items
                  row.loading = false
                  this.$set(this.tableData, 'index', row)
                } else {
                  this.$set(this.tableData[index], 'loading', false)
                }
              }
            })
        }
      }
      // return true
    },
    handleSizeChange (val) {
      this.pagesize = val
      this.initData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.initData()
    }
  },
  mounted () {
    this.initData()
    this.getCropList()
  }
}
</script>

<style lang="scss" scoped>
    .select-wrap {
        display: flex;
        align-items: center;
        margin: 20px 0;
    }

    .select-wrap > div {
        padding-right: 20px;
    }

    .checkbox {
      margin-left: 15px;
    }

    .select-company{
      margin-right: auto;
    }
</style>



// WEBPACK FOOTER //
// src/pages/user/TransDetail.vue